export const odsClaimStatusConversion = (status, claimType = "") => {
  if (claimType?.toLowerCase() === "dis") {
    switch (status?.toLowerCase()) {
      case "a":
        return ["good", "Active"];
      case "b":
        return ["problem", "Rescinded"];
      case "c":
        return ["good", "Closed"];
      case "d":
        return ["problem", "Denied"];
      case "e":
        return ["problem", "Discarded"];
      case "i":
        return ["good", "Internal referral"];
      case "o":
        return ["risk", "Open"];
      case "p":
        return ["risk", "Pending"];
      case "r":
        return ["risk", "Referred to client"];
      case "w":
        return ["risk", "Waiver of premium"];
      case "h":
        return ["risk", "Pending"];
      default:
        return ["risk", "Pending"];
    }
  } else if (claimType === "serviceRequest") {
    switch (status?.toLowerCase()) {
      case "o":
      case "p":
      case "r":
      case "h":
        return ["risk", "Pending"];
      case "c":
        return ["good", "Closed"];
      default:
        return ["risk", "Pending"];
    }
  } else {
    switch (status?.toString()) {
      case "1":
      case "01":
        return ["risk", "Pending"];

      case "93":
      case "98":
        return ["risk", "Other. Route to agent"];

      case "97":
      case "99":
        return ["good", "Completed"];

      case "92":
        return ["problem", "Denied"];
      default:
        return ["risk", "Pending"];
    }
  }
};
